import React from "react";
import { Helmet } from "react-helmet";
import { FormattedMessage, useIntl } from "react-intl";
import { useOutletContext } from "react-router";
import { PageWrapper } from "components/Containers";
import { Grid } from "components/Containers";
import PageTitle from "components/PageTitle";
import { ApplicantListLayout } from "components/Missions/Applicants";
import { APPLICANT_LIST_COLUMNS, APPLICANT_TYPES, BANNER_TYPE, MISSION_ROLE_STATES } from "constants/index";
import { Banner } from "components/Banner";
import { Spinner } from "components/Loader";

/**
 * Mission Role Recommendations
 */
const MissionRoleRecommendations = () => {
  const { selectedRole, loading } = useOutletContext();
  const intl = useIntl();

  return (
    <PageWrapper>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.Missions.Role.Recommendations.Title" })}</title>
      </Helmet>
      <Grid>
        <Grid.col start={1} end={13}>
          <PageTitle
            subtitle={<FormattedMessage id="Missions.Roles.Recommendations.Title" />}
            actionBar={
              selectedRole?.state === MISSION_ROLE_STATES.closed && (
                <Banner isClosable={false} type={BANNER_TYPE.warning}>
                  <FormattedMessage id="Missions.Roles.Recommendations.ClosedRole.BannerText" />
                </Banner>
              )
            }
          />
        </Grid.col>
        <Grid.col start={1} end={13}>
          {loading ? (
            <Spinner />
          ) : (
            <ApplicantListLayout
              initialTab={1}
              defaultSelected={{
                missionId: selectedRole?.mission?.id,
                missionRoleIds: [selectedRole?.id],
                organizationId: selectedRole?.mission?.organization?.id,
                applicantState: APPLICANT_TYPES.recommended,
              }}
              hideSorts={false}
              hideAdvancedFilters={false}
              hideTabs
              hideProgressMenu
              showAdvancedOptions
              showAdminOnlyPages
              hideOrganizationFilter
              hideMissionFilter
              hideMemberFilter
              hideFilters
              hideKeywordSearch={false}
              columns={[
                APPLICANT_LIST_COLUMNS.member,
                APPLICANT_LIST_COLUMNS.status,
                APPLICANT_LIST_COLUMNS.disciplines,
                APPLICANT_LIST_COLUMNS.location,
                APPLICANT_LIST_COLUMNS.missionStats,
                APPLICANT_LIST_COLUMNS.rate,
              ]}
              variablesProp={{
                includeFlaggedCommentsCount: true,
              }}
            />
          )}
        </Grid.col>
      </Grid>
    </PageWrapper>
  );
};

export default MissionRoleRecommendations;
